export default "__VITE_ASSET__CEw5GSAE__"